import type { Role } from '../../types';

interface LocalDevBannerProps {
  role: Role;
}

export function LocalDevBanner({ role }: LocalDevBannerProps) {
  if (import.meta.env.VITE_AUTH_BYPASS !== 'true') {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-amber-900/90 text-amber-100 text-xs py-1 px-4 text-center">
      <span className="font-medium">Local Dev Mode</span>
      <span className="mx-2">•</span>
      <span>{role}</span>
    </div>
  );
}
